import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getValueAddedServiceList(params) {
  return request({
    url: URL.mdm.basicData.valueAddedServiceList,
    method: 'get',
    params
  })
}

export function saveValueAddedService(data) {
  return request({
    url: URL.mdm.basicData.valueAddedService,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delValueAddedService(data) {
  return request({
    url: URL.mdm.basicData.valueAddedService,
    method: 'delete',
    data
  })
}

export function checkValueAddedService(data) {
  return request({
    url: URL.mdm.basicData.checkValueAddedService,
    method: 'post',
    data
  })
}

export function initValueAddedService() {
  return request({
    url: URL.mdm.basicData.initValueAddedService,
    method: 'post'
  })
}

